import { put, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import GlobalActions from 'store/redux/global'
import AuthActions from 'store/redux/auth'
import MCActions from 'store/redux/mc'
import Socket from 'api'
import ERROR from 'utils/errors'
import { sortBy } from 'lodash'
import { gameDataFromLogs, updateGameDataWithLog } from 'utils/dataEnhancer/logs'
import { downloadFileFromStringData } from 'utils/download'

export function* requestNewGameTemplate() {
    yield put(GlobalActions.showLoading())
    Socket.emitters().mc.requestNewGameTemplate()
}

export function* handleNewGameTemplateData({ response }) {
    const { ok, problem, data } = response
    if (ok) {
        yield put(MCActions.setNewGameTemplate(data))
        yield put(push('/mc/new-game/step1'))
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* newGameSaveStep1({ data }) {
    yield put(MCActions.setNewGameConfiguration(data))
    yield put(push('/mc/new-game/step2'))
}
export function* newGameSaveStep2({ data }) {
    const { newGameConfiguration = {} } = yield select(state => state.mc)
    const allData = { ...newGameConfiguration, ...data }
    yield put(MCActions.setNewGameConfiguration(allData))
    yield* requestNewGame({ data: allData })
}

export function* requestNewGame({ data }) {
    yield put(GlobalActions.showLoading())
    Socket.emitters().mc.requestNewGame(data)
}

export function* handleNewGameData({ response }) {
    const { ok, problem, data } = response
    if (ok && data && data.gameCode) {
        yield put(MCActions.setNewGameCode(data.gameCode))
        yield* requestBotsDefaultValues({ gameCode: data.gameCode })
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
        yield put(GlobalActions.hideLoading())
    }
}

export function* requestBotsDefaultValues({ gameCode }) {
    yield put(GlobalActions.showLoading())
    Socket.emitters().mc.requestGameBotsDefaultValues({ gameCode })
}

export function* handleBotsDefaultValues({ response }) {
    const { ok, problem, data } = response
    if (ok) {
        yield put(MCActions.addToNewGameTemplate({ bots: data }))
        yield put(push('/mc/new-game/step3'))
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* updateGameBots({ data }) {
    yield put(GlobalActions.showLoading())
    const { gameCode } = yield select(state => state.mc.newGameConfiguration)
    Socket.emitters().mc.updateGameBots({ ...data, gameCode })
}

export function* handleGameBotsUpdated({ response }) {
    const { ok, problem, data } = response
    if (ok) {
        const data = yield select(state => state.mc.newGameConfiguration)
        yield* requestGameData({ data })
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
        yield put(GlobalActions.hideLoading())
    }
}

export function* requestGameData({ data }) {
    if (!data.hideLoading) yield put(GlobalActions.showLoading())
    const { gameCode, panel, season } = data
    // console.log(['Params', { gameCode, panel: panel || 'DECISIONS', season }])
    Socket.emitters().mc.requestGame({ gameCode, panel: panel || 'DECISIONS', season })
}

export function* handleGameData({ response }) {
    const { game: prevGame } = yield select(state => state.mc)
    const { ok, problem, data } = response

    // console.log(['Response', response])
    if (ok && data && data.currentSeason && (data.decisions || data.ranking)) {
        // yield put(MCActions.clean())
        yield put(MCActions.setGame(data))
        yield put(push('/mc/game'))
    } else if (problem === 'game_not_found') {
        yield put(GlobalActions.error(ERROR.GAME_NOT_FOUND))
    }

    yield put(AuthActions.setReconnecting(false))
    yield put(GlobalActions.hideLoading())
}

export function* handleGameLogData({ response }) {
    const { ok, problem, data } = response
    if (ok) {
        const originalLog = data
        const {
            game: prevGame,
            players: { byId: prevPlayersById }
        } = yield select(state => state.mc)
        const { game, playersById, log } = updateGameDataWithLog(prevGame, prevPlayersById, originalLog)
        yield put(MCActions.setGame(game))
        const players = sortBy(Object.keys(playersById).map(id => playersById[id]), ['position', 'id'])
        yield put(MCActions.setPlayers(players))
        yield put(MCActions.addLogToTimeline(log))
    }
}

export function* requestGameList() {
    yield put(GlobalActions.showLoading())
    Socket.emitters().mc.requestGameList()
}

export function* handleGameList({ response }) {
    const { ok, data } = response
    if (ok) {
        yield put(MCActions.setGameList(data))
        yield put(push('/mc/games'))
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* requestGameCSV({ code }) {
    yield put(GlobalActions.showLoading())
    Socket.emitters().mc.requestGameCSV({ code })
}

export function* handleGameCSV({ response }) {
    const { ok, data } = response
    if (ok && data && data.code && data.csv) {
        downloadFileFromStringData(`${data.code}-decisions.csv`, data.csv)
    } else {
        yield put(GlobalActions.error(ERROR.UNKNOWN))
    }
    yield put(GlobalActions.hideLoading())
}

export function* handleServerError({ response }) {
    yield put(
        GlobalActions.error({
            title: response.title || 'Ooops!',
            text: response.text || 'Unknown error'
        })
    )
    yield put(GlobalActions.hideLoading())
}



// WEBPACK FOOTER //
// src/store/sagas/mc.js